import script from "./LoginForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginForm.vue?vue&type=script&setup=true&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=95c95848&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95c95848"]])

export default __exports__